import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import EuroIcon from '@mui/icons-material/Euro'
import MenuIcon from '@mui/icons-material/Menu'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import LocalMallIcon from '@mui/icons-material/LocalMallOutlined'
import { Grid, Stack, Typography } from '@mui/material'
import DashboardMainInfoItem from '../../components/DashboardMainInfoItem'
import DashboardDivider from '../../components/DashboardDivider'

interface IBasicInfo {
  readonly isLoading: boolean
  readonly dashboardStats?: any
}

const BasicInfo = ({ isLoading, dashboardStats }: IBasicInfo) => (
  <Stack spacing={3}>
    <Stack p={3} borderRadius={4} spacing={4}>
      <Typography fontSize={16} fontWeight={600} color="primary">
        Social Media Management Dashboard
      </Typography>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          gap: { xs: 2, md: 0 },
        }}
      >
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Monthly Revenue"
            value={
              dashboardStats?.monthlyRevenue != null
                ? `€${dashboardStats.monthlyRevenue.toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                : 'N/A'
            }
            Icon={<EuroIcon htmlColor="#fff" fontSize="large" />}
          />
        </Grid>
        <Grid
          item
          xs={0.45}
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
          }}
        >
          <DashboardDivider />
        </Grid>
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Planned Budget"
            value={
              dashboardStats?.plannedBudget != null
                ? `€${dashboardStats.plannedBudget.toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                : 'N/A'
            }
            Icon={<MenuIcon fontSize="large" htmlColor="#fff" />}
          />
        </Grid>
        <Grid
          item
          xs={0.45}
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
          }}
        >
          <DashboardDivider />
        </Grid>
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Total Expenses"
            value="N/A"
            Icon={<EuroIcon htmlColor="#fff" fontSize="large" />}
          />
        </Grid>
        <Grid
          item
          xs={0.45}
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
          }}
        >
          <DashboardDivider />
        </Grid>
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Margin"
            value={
              dashboardStats?.margin != null
                ? `€${dashboardStats.margin.toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                : 'N/A'
            }
            Icon={<ArrowOutwardIcon htmlColor="#fff" fontSize="large" />}
          />
        </Grid>
      </Grid>
    </Stack>
    <Stack p={3} borderRadius={4} spacing={4}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          gap: { xs: 2, md: 0 },
        }}
      >
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Active Customers"
            value={
              dashboardStats?.activeCustomers != null
                ? dashboardStats.activeCustomers.toLocaleString('de-DE')
                : 0
            }
            Icon={<PeopleOutlineOutlinedIcon htmlColor="#fff" fontSize="large" />}
          />
        </Grid>
        <Grid
          item
          xs={0.45}
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
          }}
        >
          <DashboardDivider />
        </Grid>
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Orders"
            value={
              dashboardStats?.totalOrders != null
                ? dashboardStats.totalOrders.toLocaleString('de-DE')
                : 0
            }
            Icon={<LocalMallIcon fontSize="large" htmlColor="#fff" />}
          />
        </Grid>
        <Grid
          item
          xs={0.45}
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
          }}
        >
          <DashboardDivider />
        </Grid>
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Generated Leads"
            value={
              dashboardStats?.generatedLeads != null
                ? dashboardStats.generatedLeads.toLocaleString('de-DE')
                : 0
            }
            Icon={<HowToRegOutlinedIcon htmlColor="#fff" fontSize="large" />}
          />
        </Grid>
        <Grid
          item
          xs={0.45}
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
          }}
        >
          <DashboardDivider />
        </Grid>
        <Grid item md={2.3} xs={12}>
          <DashboardMainInfoItem
            isLoading={isLoading}
            title="Software Accounts"
            value={
              dashboardStats?.softwareAccounts != null
                ? dashboardStats.softwareAccounts.toLocaleString('de-DE')
                : 0
            }
            Icon={<EuroIcon htmlColor="#fff" fontSize="large" />}
          />
        </Grid>
      </Grid>
    </Stack>
  </Stack>
)

export default BasicInfo
